import { Button, Tooltip } from "@fluentui/react-components";
import {
  ArrowDownloadRegular,
  DeleteDismissRegular,
  CheckmarkFilled,
  DismissFilled,
  PersonQuestionMarkRegular,
  ArrowSplitFilled,
} from "@fluentui/react-icons";
import { HSpace } from "@greco/components/dist/components/utils";
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
} from "@silevis/reactgrid";
import { HorizontalSpacer } from "components/styled";
import * as React from "react";

export interface ReminderEntryOptionsCell extends Cell {
  type: "ReminderEntryoptions";
  link?: string;
  deleteFn?: any;
  saveFn?: any;
  cancelFn?: any;
  resolvementSuggestFn?: any;
  clearFn?: any;
  rowId?: any;
  clientId?: any;
  edited?: boolean;
  isDisabled?: boolean;
  isCleared?: boolean;
  t: any;
}

export class ReminderEntryOptionsCellTemplate
  implements CellTemplate<ReminderEntryOptionsCell>
{
  getCompatibleCell(
    uncertainCell: Uncertain<ReminderEntryOptionsCell>
  ): Compatible<ReminderEntryOptionsCell> {
    let link: string | undefined;
    let t: any;
    t = getCellProperty(uncertainCell, "t", "function");

    try {
      link = getCellProperty(uncertainCell, "link", "string");
    } catch {
      link = undefined;
    }
    let clientId: any;

    try {
      clientId = getCellProperty(uncertainCell, "clientId", "number");
    } catch {
      clientId = undefined;
    }

    let saveFn: any;
    try {
      saveFn = getCellProperty(uncertainCell, "saveFn", "function");
    } catch {
      saveFn = undefined;
    }

    let cancelFn: any;
    try {
      cancelFn = getCellProperty(uncertainCell, "cancelFn", "function");
    } catch {
      cancelFn = undefined;
    }

    let resolvementSuggestFn: any;
    try {
      resolvementSuggestFn = getCellProperty(
        uncertainCell,
        "resolvementSuggestFn",
        "function"
      );
    } catch {
      resolvementSuggestFn = undefined;
    }

    let clearFn: any;
    try {
      clearFn = getCellProperty(uncertainCell, "clearFn", "function");
    } catch {
      clearFn = undefined;
    }

    let deleteFn: any;
    try {
      deleteFn = getCellProperty(uncertainCell, "deleteFn", "function");
    } catch {
      deleteFn = undefined;
    }

    let rowId: any;

    try {
      rowId = getCellProperty(uncertainCell, "rowId", "number");
    } catch {
      rowId = undefined;
    }

    let isDisabled = true;
    try {
      isDisabled = getCellProperty(uncertainCell, "isDisabled", "boolean");
    } catch {
      isDisabled = false;
    }

    let isCleared = true;
    try {
      isCleared = getCellProperty(uncertainCell, "isCleared", "boolean");
    } catch {
      isCleared = false;
    }

    let edited = false;
    try {
      edited = getCellProperty(uncertainCell, "edited", "boolean");
    } catch {
      edited = false;
    }

    // let inputValue: string | undefined;
    // try {
    //   inputValue = getCellProperty(uncertainCell, "inputValue", "string");
    // } catch {
    //   inputValue = undefined;
    // }

    const text = link;
    return {
      ...uncertainCell,
      link,
      text,
      rowId,
      clientId,
      deleteFn,
      clearFn,
      cancelFn,
      resolvementSuggestFn,
      saveFn,
      value: NaN,
      isDisabled,
      isCleared,
      edited,
      t, // isOpen,
      // inputValue,
    };
  }

  getClassName(
    cell: Compatible<ReminderEntryOptionsCell>,
    isInEditMode: boolean
  ): string {
    return `${cell.className ? cell.className : ""}`;
  }

  render(
    cell: Compatible<ReminderEntryOptionsCell>,
    isInEditMode: boolean,
    onCellChanged: (
      cell: Compatible<ReminderEntryOptionsCell>,
      commit: boolean
    ) => void
  ): React.ReactNode {
    return <OptionsCell cell={cell} />;
  }
}

interface DIProps {
  cell: Record<string, any>;
}

const OptionsCell: React.FC<DIProps> = ({ cell }) => {
  if (cell.isCleared) {
    return null;
  }
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      {cell.edited ? (
        <>
          {cell.saveFn && cell.edited ? (
            <Tooltip content={cell.t("greco.save")} relationship="label">
              <Button
                appearance="subtle"
                size="small"
                icon={cell.edited ? <CheckmarkFilled /> : <CheckmarkFilled />}
                style={{ color: "green" }}
                onClick={(e) => {
                  cell.saveFn(cell.rowId);
                }}
              ></Button>
            </Tooltip>
          ) : null}
          {cell.cancelFn ? (
            <Tooltip content={cell.t("greco.cancel")} relationship="label">
              <Button
                appearance="subtle"
                size="small"
                icon={cell.edited ? <DismissFilled /> : <DismissFilled />}
                style={{ color: "red" }}
                onClick={(e) => {
                  cell.cancelFn(cell.rowId);
                }}
              ></Button>
            </Tooltip>
          ) : null}
        </>
      ) : null}
      {!cell.edited ? (
        <>
          {cell.clientInfo ? (
            <Tooltip
              content={cell.t("pct.clearEntry.label")}
              relationship="label"
            >
              <Button
                appearance="subtle"
                size="small"
                icon={<ArrowSplitFilled />}
                onClick={(e) => {
                  window.open(cell.link, "_blank");
                }}
              ></Button>
            </Tooltip>
          ) : (
            <>
              {!cell.clientId ? (
                <Tooltip
                  content={cell.t("pct.suggestClientResolvement.label")}
                  relationship="label"
                >
                  <Button
                    appearance="subtle"
                    size="small"
                    icon={<PersonQuestionMarkRegular />}
                    onClick={(e) => {
                      cell.resolvementSuggestFn(cell.rowId);
                    }}
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip
                  content={cell.t("pct.clearPaymentsToEntries.label")}
                  relationship="label"
                >
                  <Button
                    appearance="subtle"
                    size="small"
                    icon={<ArrowSplitFilled />}
                    onClick={(e) => {
                      cell.clearFn(cell.rowId);
                    }}
                  ></Button>
                </Tooltip>
              )}
            </>
          )}
          {cell.deleteFn ? (
            <Tooltip
              content={cell.t("pct.deleteReminderEntry.label")}
              relationship="label"
            >
              <Button
                appearance="subtle"
                size="small"
                icon={<DeleteDismissRegular />}
                onClick={(e) => {
                  cell.deleteFn(cell.rowId);
                }}
              ></Button>
            </Tooltip>
          ) : (
            <div
              style={{
                width: "24px",
                height: "24px",
                alignItems: "center",
                boxSizing: "border-box",
                display: "inline-flex",
                justifyContent: "center",
                textDecorationLine: "none",
                verticalAlign: "middle",
                margin: "0px",
                overflow: "hidden",
              }}
            />
          )}
        </>
      ) : null}
    </div>
  );
};
